module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2022_18.a0c7f95e.jpg";